import {Toaster as RHTToaster} from 'react-hot-toast'
import {useTheme} from 'styled-components'

const Toaster = () => {
    const theme = useTheme()
    return (
        <RHTToaster
            position="bottom-center"
            toastOptions={{
                duration: 8000,
                success: {
                    iconTheme: {
                        primary: theme.palette.green['500'],
                        secondary: theme.palette.neutral['white']
                    }
                },
                style: {
                    minWidth: 360,
                    padding: `${theme.spacing * 2}px ${theme.spacing * 3}px`,
                    boxShadow: theme.shadows.md,
                    backgroundColor: theme.palette.neutral.white
                }
            }}
        />
    )
}

export default Toaster
